import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import {FormField} from '../models/forms';

export function isNonEmptyTrimmed(value: any): boolean {
  return typeof value === 'string' ? value.trim().length > 0 : !!value;
}

export function clearInputOnlySpaces(form: FormGroup, fields: FormField[], isSubmit = true) {
  if(!form) return;
  Object.keys(form.controls).forEach(key => {
    const control = form.get(key);
    if(!control) return;
    const value = control.value;
    if(typeof value === 'string' && value.length > 0) {
      let trimmed = value.trim();
      const field = fields?.find(f => f.name === key);
      if(field?.trimSet) {
        const regex = new RegExp(`[${field.trimSet}]`, 'g');
        trimmed = trimmed.replace(regex, '');
      }
      if(isSubmit) {
        if(trimmed !== value) {
          control.setValue(trimmed, {emitEvent: false});
        }
      } else {
        if(trimmed.length === 0 && value.length > 0) {
          control.setValue('', {emitEvent: false});
        }
      }
    }
  });
}

export function setRequireOneOfError(form: FormGroup, group: string[], baseKey?: string, errorKey = 'requireOneOf') {
  const key = baseKey || group[0];
  if(!key) return;
  const hasAny = group.some(name => isNonEmptyTrimmed(form.get(name)?.value));
  const baseCtrl = form.get(key);
  if(!hasAny) {
    if(baseCtrl) {
      baseCtrl.setErrors({...(baseCtrl.errors || {}), [errorKey]: {fields: group}});
    }
    group.slice(1).forEach(name => {
      const control = form.get(name);
      if(control?.errors?.[errorKey]) {
        const {[errorKey]: _, ...rest} = control.errors as any;
        control.setErrors(Object.keys(rest).length ? rest : null);
      }
    });
    return true;
  } else {
    group.forEach(name => {
      const control = form.get(name);
      if(!control || !control.errors) return;
      const {[errorKey]: _, ...rest} = control.errors as any;
      control.setErrors(Object.keys(rest).length ? rest : null);
    });
    return false;
  }
}

export function atLeastOneNonEmptyValidator(fieldNames: string[], baseKey?: string, errorKey = 'requireOneOf'): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const fg = group as FormGroup;
    const hasOne = fieldNames.some(name => isNonEmptyTrimmed(fg.get(name)?.value));
    const key = baseKey || fieldNames[0];
    const base = fg.get(key);
    if(!hasOne) {
      if(base) base.setErrors({...(base.errors || {}), [errorKey]: {fields: fieldNames}});
      return {atLeastOneName: true};
    }
    if(base && base.errors) {
      const {[errorKey]: _, ...rest} = base.errors as any;
      base.setErrors(Object.keys(rest).length ? rest : null);
    }
    return null;
  };
}
